export default __webpack_public_path__ + "static/media/pic2.db910b7a.png";